import { mixins } from 'sonata-react-components';
import styled from 'styled-components';

export const NotificationSettingsStyled = styled.div`
  font-family: ${props => props.theme.fontRegular};
  .userNotifications{
    width: 820px;
    margin: 1rem auto;
  
    .userNotifications {
      &__alarmsResume {
        display: flex;
        padding: 0.5rem 0.625rem;
        justify-content: center;
        background-color: ${props => props.theme.brandActive};
        color: ${props => props.theme.bgColor};
        span {
          font-size: 0.8rem;
          margin: 0 2px;
        }
        border-top-left-radius: 5px;
        border-top-right-radius: 5px;
      
        .enabledAlarms,
        .subscribedAlarms{
          flex-grow: 1;
          text-align: center;
        }
      
        border: solid 1px ${props => props.theme.grayUltraUltraLight};
        border-bottom: none;
      }
    }
  
    .userNotifications__enabledAlarmsInfoToggle,
    .userNotifications__subscribedAlarmsInfoToggle {
      font-size: 1rem;
      cursor: pointer;
    }
  
    .userNotifications__alarms {
      margin-bottom: 0;
      display: block;
      width: 100%;
      border: solid 1px ${props => props.theme.grayUltraUltraLight};
      border-top: none;
  
      &--withoutBar::before {
        height: 0;
      }
  
      .toggle {
        width: 12.5%;
      }
  
      .settings {
        width: 12.5%;
      }
  
      .userNotifications__alarmsControls {
        display: flex;
        margin: 0;
        width: 100%;
        border-bottom: solid 1px ${props => props.theme.grayUltraUltraLight};
        position: relative;
        cursor: default;
        padding: 0.8rem 0;
  
        .footNote {
          color: ${props => props.theme.bgColor};
          white-space: nowrap;
          font-size: 0.75rem;
          cursor: default;
          padding-left: 0.625rem;
          padding-right: 0.625rem;
  
          &[data-sort-by] {
            cursor: pointer;
          }
  
          float: left;
  
          &.toggle {
            text-align: center;
            width: 12.5%;
          }
  
          &.name {
            width: 25%;
          }
  
          &.description {
            width: 33.33333%;
          }
  
          &.settings {
            text-align: center;
            width: 12.5%
          }
  
          &.subscription {
            text-align: center;
            float: right;
            width: 16.66667%;
          }
        }
      }
  
      .userNotifications__alarmsItems {
        display: flex;
        width: 100%;
        height: 300px;
        flex-direction: column;
        position: relative;
        overflow-y: auto;
        ${mixins.forceScrollbar};
      }
    }
  
    .userNotifications__alarmSubscriptionSettings {
      padding-top: 1rem;
      float: right;
      display: flex;
      flex-direction: row;
      .columns {
        &:first-child {
          padding-left: 0;
        }
        &:nth-child(2) {
          padding-right: 0;
        }
      }
      label {
        font-size: 0.8rem;
        color: ${props => props.theme.textColor};
        line-height: 37px;
        margin-right: 1rem;
      }
      input {
        width: 300px;
        font-size: 0.9rem;
        text-align: right;
        padding: 0.6rem 0.3rem;
      }
    }
  }
`;
